import { defineStore } from 'pinia'
import { pickBy } from 'lodash'

export const useStoryBatchOptionsStore = defineStore('storyBatchOptions', {
  state: () => ({
    selectedStoryIds: [],
    pubDate: '',
    userId: '',
    sectionId: '',
    squeueId: '',
    webCategoryId: '',
    // Advanced options state
    advancedPublicationIds: [],
    advancedPublicationMode: 'append',
    advancedIssueIds: [],
    advancedIssueAssignmentMode: 'append',
    advancedSubsiteIds: [],
    advancedSubsiteMode: 'append',
    advancedFeatured: '',
    advancedIspublic: '',
    advancedKeywords: '',
    advancedKeywordsMode: 'append',
    advancedNotes: '',
    advancedNotesMode: 'append'
  }),

  getters: {
    checked: ({ selectedStoryIds }) => (id) => { return selectedStoryIds.includes(id) },

    storyData({ pubDate, userId, sectionId, squeueId, webCategoryId }) {
      return pickBy(
        {
          pub_date: pubDate,
          user_id: userId,
          section_id: sectionId,
          squeue_id: squeueId,
          web_category_id: webCategoryId
        }
      )
    },

    anyChanges() {
      return Object.keys(this.storyData).length > 0
    },

    advancedStoryData({ advancedFeatured, advancedIspublic }) {
      return pickBy({ featured: advancedFeatured, ispublic: advancedIspublic }, (v) => v !== '')
    },

    advancedBatchData({ advancedPublicationIds, advancedPublicationMode, advancedIssueIds, advancedIssueAssignmentMode, advancedSubsiteIds, advancedSubsiteMode, advancedKeywords, advancedKeywordsMode, advancedNotes, advancedNotesMode }) {
      const data = {}
      if (advancedPublicationIds.length > 0) {
        data.publication_ids = advancedPublicationIds
        data.publication_mode = advancedPublicationMode
      }
      if (advancedIssueIds.length > 0) {
        data.issue_ids = advancedIssueIds
        data.issue_assignment_mode = advancedIssueAssignmentMode
      }
      if (advancedSubsiteIds.length > 0) {
        data.subsite_ids = advancedSubsiteIds
        data.subsite_mode = advancedSubsiteMode
      }
      if (advancedKeywords.trim()) {
        data.keywords = advancedKeywords.trim()
        data.keywords_mode = advancedKeywordsMode
      }
      if (advancedNotes.trim()) {
        data.notes = advancedNotes.trim()
        data.notes_mode = advancedNotesMode
      }
      return data
    },

    anyAdvancedChanges() {
      return Object.keys(this.advancedStoryData).length > 0 || Object.keys(this.advancedBatchData).length > 0
    },

    selectedStoriesCount({ selectedStoryIds }) {
      return selectedStoryIds.length
    },

    anySelectedStories() {
      return this.selectedStoriesCount > 0
    },
  },

  actions: {
    set(key, value) {
      value ? this.check(key) : this.uncheck(key)
    },

    check(key) {
      if(this.selectedStoryIds.includes(key)) return

      this.selectedStoryIds.push(key)
    },

    uncheck(key) {
      this.selectedStoryIds = this.selectedStoryIds.filter(id => id !== key)
    },

    uncheckAll() {
      this.selectedStoryIds = []
    },

    resetAdvanced() {
      this.advancedPublicationIds = []
      this.advancedPublicationMode = 'append'
      this.advancedIssueIds = []
      this.advancedIssueAssignmentMode = 'append'
      this.advancedSubsiteIds = []
      this.advancedSubsiteMode = 'append'
      this.advancedFeatured = ''
      this.advancedIspublic = ''
      this.advancedKeywords = ''
      this.advancedKeywordsMode = 'append'
      this.advancedNotes = ''
      this.advancedNotesMode = 'append'
    }
  },
})

